import gsap from 'gsap'
import barba from '@barba/core'
import { smoothScroller, snapToTop } from './smoothScroller.js'
import { animation } from './animation.js'
import { datepicker } from './datepicker.js'
import { navigation } from './navigation.js'
import { splitText } from './splitText.js'
import { careers } from './careers.js'
import { swiper } from './swiper.js'
import { popup } from './popup.js'
import { home } from './home.js'
import { offers } from './offers.js'
import { enter } from './enter.js'
import { rooms } from './rooms.js'
import { select } from './select.js'
import { map } from './map.js'
import { accordion } from './accordion.js'
import { initEventbrite } from './eventbrite.js'

const initBarba = () => {

	barba.init({
		debug: false,
		schema: {
			prefix: 'data-load',
		},
		prevent: ({ el }) => el.classList.contains('ab-item'),
		transitions: [{
			sync: true,
			once(data) {
				if (data.next.container.dataset.setHeaderTheme) {
					document.body.setAttribute('data-header-theme', data.next.container.dataset.setHeaderTheme)
				}
				setTimeout(() => document.body.setAttribute('data-entrance-animation', 'in-progress'), 200);
				setTimeout(() => document.body.setAttribute('data-entrance-animation', 'complete'), 1500);
			},
			leave(data) {
				document.body.removeAttribute('data-navigation-status')
				return gsap.to(data.current.container, {
					duration: 1.35,
					yPercent: -25,
					opacity: 0.1,
					ease: 'expo.inOut'
				})
			},
			enter(data) {
				console.log(data.next.container.dataset.setHeaderTheme)
				if (data.next.container.dataset.setHeaderTheme) {
					document.body.setAttribute('data-header-theme', data.next.container.dataset.setHeaderTheme)
				}
				// if (data.next.namespace == 'home' || data.next.namespace == 'rooms') {
				// 	setTimeout(() => {
				// 		document.body.setAttribute('data-header-theme', 'white')
				// 	}, 600);
				// } else {
				// 	setTimeout(() => {
				// 		document.body.setAttribute('data-header-theme', 'black')
				// 	}, 0);
				// }
				return gsap.fromTo(
					data.next.container,
					{
						yPercent: 100
					},
					{
						duration: 1.45,
						yPercent: 0,
						ease: 'power4.inOut'
					}
				)
			},
		}]
	})

	barba.hooks.once((data) => {
		smoothScroller()
		setTimeout(() => enter(), 1500);
		setTimeout(() => animation(), 1500);
		datepicker()
		navigation()
		splitText()
		careers()
		swiper()
		popup()
		home()
		offers()
		rooms()
		select()
		map()
		accordion()
		initEventbrite()
	})

	barba.hooks.after((data) => {
		smoothScroller()
		datepicker()
		animation()
		splitText()
		careers()
		swiper()
		popup()
		home()
		offers()
		rooms()
		select()
		map()
		accordion()
		initEventbrite()
		const scripts = document.querySelectorAll('main script')
		scripts.forEach((script) => eval(script.innerHTML))
	})

}

export default initBarba